export default __webpack_public_path__ + "static/media/arrows.54d1db16.svg";